import type { PublishInteractionStartedSource } from 'types/fedops/publishInteraction';
import type { EditorAPI } from '#packages/editorAPI';

export interface CustomTemplatePublishSuccessPanelOwnProps {
  sourceOfStart: PublishInteractionStartedSource;
}

export interface CustomTemplatePublishSuccessPanelMapStateToProps {
  templateId: string;
  editorAPI: EditorAPI;
}

export interface CustomTemplatePublishSuccessPanelDispatchProps {
  setDontShowPanelValue: () => void;
}

export type CustomTemplatePublishSuccessPanelProps =
  CustomTemplatePublishSuccessPanelOwnProps &
    CustomTemplatePublishSuccessPanelMapStateToProps &
    CustomTemplatePublishSuccessPanelDispatchProps;

export interface PublishSuccessPanelState {
  dontShowAgain: boolean;
}

export enum BiActions {
  ClickClose = 'click_close',
  ClickViewSite = 'click_view_site',
  ClickLearnMore = 'click_learn_more',
  ClickDone = 'click_done',
  ClickOutside = 'click_outside',
  ClickEscapeKeyboard = 'click_escape_keyboard',
  ClickEnterKeyboard = 'click_enter_keyboard',
}
